import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { EventCalendar } from "@/components/EventCalendar";
import { EventCard } from "@/components/EventCard";
import { useUpcomingEvents } from "@/hooks/useEvents";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cursor, setCursor] = useState(() => {
    const d = new Date();
    return { year: d.getFullYear(), month: d.getMonth() };
  });

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).finally(() => setLoading(false));
  }, []);

  const upcoming = useUpcomingEvents(events);
  const goPrev = () => setCursor((c) => c.month === 0 ? { year: c.year - 1, month: 11 } : { ...c, month: c.month - 1 });
  const goNext = () => setCursor((c) => c.month === 11 ? { year: c.year + 1, month: 0 } : { ...c, month: c.month + 1 });

  return (
    <div data-testid="events-page">
      <section className="bg-[#003B5C] py-28 lg:py-36 relative grain-overlay">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4A437] mb-6">Events</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95] text-white max-w-4xl">
            Stay connected.
          </h1>
          <p className="mt-8 text-lg text-white/75 max-w-2xl">
            From spiritual retreats to family outings — there's always something happening at Ebenezer.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-7">
              <EventCalendar events={events} cursor={cursor} onPrev={goPrev} onNext={goNext} />
            </div>

            <div className="lg:col-span-5">
              <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#003B5C] mb-6">Upcoming</h2>
              {loading ? (
                <div data-testid="events-loading" className="text-[#1E1E1E]/60">Loading events…</div>
              ) : upcoming.length === 0 ? (
                <div data-testid="events-empty" className="text-[#1E1E1E]/60">No upcoming events. Check back soon!</div>
              ) : (
                <div className="space-y-4">
                  {upcoming.map((ev) => <EventCard key={ev.id} ev={ev} />)}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
